import React from 'react';

const Icon = ({ width = '50', height = '49', fill = 'white', ...other }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 50 49" fill="none" {...other}>
            <g clipPath="url(#a)" stroke="black" strokeWidth="2.267" strokeLinecap="round" strokeLinejoin="round">
                <path d="M42.478 11.164H7.724a2.267 2.267 0 0 0-2.267 2.267v22.665a2.267 2.267 0 0 0 2.267 2.267h34.754a2.267 2.267 0 0 0 2.266-2.267V13.431a2.267 2.267 0 0 0-2.266-2.267Zm-8.311 16.621h6.044m-6.044 4.533h6.044" />

                <path d="M28.123 15.697H11.5a1.51 1.51 0 0 0-1.51 1.511v15.11c0 .835.676 1.512 1.51 1.512h16.622a1.51 1.51 0 0 0 1.51-1.511v-15.11c0-.835-.676-1.512-1.51-1.512Z" />

                <circle cx="37.189" cy="20.229" r="3.022" />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill={fill} d="M.924.586h48.353v48.353H.924z" />
                </clipPath>
            </defs>
        </svg>
    );
};
export default React.memo(Icon);
